module.exports = __webpack_public_path__ + "static/artist-marketing-the-process-mobile-edf45e64c6a372cda9e9151af98a7a6b.png";